  import Card from "@material-tailwind/react/Card";
  import CardBody from "@material-tailwind/react/CardBody";
  import React, { useEffect, useState } from "react";
  import {
    BiArrowBack,
    BiCheckSquare,
    BiDetail,
    BiEdit,
    BiPlus,
    BiPrinter,
    BiLockOpen,
  } from "react-icons/bi";
  import { BsFileEarmarkExcelFill } from "react-icons/bs";
  import { useDispatch, useSelector } from "react-redux";
  import { useNavigate } from "react-router-dom";
  import { toast } from "react-toastify";


  import { Colors } from "../../assets/Colors";
  import Spinner from "../spinner/Spinner";

  import { maxPageGlobal } from "../../assets/config";
  import {
    jobRequestTransaksiSelector,
    kirimJobRequest,
    kirimResetPassword,
  } from "../../features/hrd/transaksi/job-request/jobRequestTransaksiSlice";
  import {
    approvalSelector,
    approve,
    kirimActivity,
    kirimPermintaanUnit,
    kirimPermit,
    kirimShippingManifest,
  } from "../../features/setup/approval/approvalSlice";
  import Skeltons from "../loading/Skeltons";

  import {
    getMinTipeKaryawan,
    tipeKaryawanSelector,
  } from "../../features/master/tipe-karyawan/tipeKaryawanSlice";

  import DatePicker from "react-datepicker";

  import { deletePerbaikanTransaksi } from "../../features/hrd/transaksi/perbaikan-absen/perbaikanTransaksiSlice";
  import { deleteLembur } from "../../features/hrd/transaksi/lembur/lemburTransaksiSlice";

  export default function CardTable(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breakpoint = 620;
    const [width, setWidth] = React.useState(window.innerWidth);
    const [search, setSearch] = React.useState("");
    const [searchTipeKaryawanValue, setsearchTipeKaryawanValue] =
      React.useState("");
    const [currentPage, setCurrentPage] = React.useState(props.currentPage);
    const [currentCount, setCurrentCount] = React.useState(maxPageGlobal);
    const [pagingOne, setPagingOne] = React.useState(1);
    const [pagingTwo, setPagingTwo] = React.useState(2);
    const [pagingThree, setPagingThree] = React.useState(3);
    const [pagingFour, setPagingFour] = React.useState(4);
    const [pagingFive, setPagingFive] = React.useState(5);
    const [editEnabled, setEditEnabled] = React.useState(
      props.editEnabled ? props.editEnabled : false
    );
    const [isSuccess, setisSuccess] = React.useState(false);
    let user = JSON.parse(localStorage.getItem("user"));

    const cuti = useSelector(approvalSelector);
    const jobRequest = useSelector(jobRequestTransaksiSelector);
    const tipeKaryawan = useSelector(tipeKaryawanSelector);

    useEffect(() => {
      // if (props.searchTipeKaryawan) {
      //   dispatch(getMinTipeKaryawan({ search: "" }));
      // }
      if (isSuccess) {
        toast.success("Success!", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "light",
        });
        setisSuccess(false);
      }
      if (currentPage < 3) {
        setPagingOne(1);
        setPagingTwo(2);
        setPagingThree(3);
        setPagingFour(4);
        setPagingFive(5);
      } else if (props.maxPage < 5) {
        setPagingOne(1);
        setPagingTwo(2);
        setPagingThree(3);
        setPagingFour(4);
        setPagingFive(5);
      } else if (currentPage > props.maxPage - 2 && props.maxPage > 4) {
        setPagingOne(props.maxPage - 4);
        setPagingTwo(props.maxPage - 3);
        setPagingThree(props.maxPage - 2);
        setPagingFour(props.maxPage - 1);
        setPagingFive(props.maxPage);
      } else {
        setPagingOne(currentPage - 2);
        setPagingTwo(currentPage - 1);
        setPagingThree(currentPage);
        setPagingFour(currentPage + 1);
        setPagingFive(currentPage + 2);
      }
    });
    // const getDataFromURL = (url) =>
    //   new Promise((resolve, reject) => {
    //     url = url.replaceAll("/", "-");
    //     setTimeout(() => {
    //       fetch(process.env.REACT_APP_API_URL + "pdf?id=" + url, {
    //         method: "GET", // or 'PUT'
    //         headers: {
    //           Accept: "*/*",
    //           Authorization: "Bearer " + user.Token,
    //         },
    //       })
    //         .then((response) => response.blob())
    //         .then((data) => {
    //           const file = window.URL.createObjectURL(data);
    //           window.open(file);
    //         });
    //     });
    //   }, 2000);


    const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      const encodedUrl = encodeURIComponent(url); // encoding agar URL valid
      const apiUrl = `${process.env.REACT_APP_API_URL}pdf?id=${encodedUrl}`;

      setTimeout(() => {
        fetch(apiUrl, {
          method: "GET",
          headers: {
            Accept: "*/*",
            Authorization: "Bearer " + user.Token,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Fetch failed with status ${response.status}`);
            }
            return response.blob();
          })
          .then((data) => {
            const fileUrl = window.URL.createObjectURL(data);
            window.open(fileUrl);
            resolve(); // Promise selesai dengan sukses
          })
          .catch((error) => {
            console.error("Fetch error:", error);
            alert("Gagal mengambil file: " + error.message);
            reject(error); // Promise gagal
          });
      }, 2000);
    });


    const getDataGeneralFromURL = (url) =>
      new Promise((resolve, reject) => {
        url = url.replaceAll("/", "-");
        setTimeout(() => {
          fetch(process.env.REACT_APP_API_URL + "pdfInvoice?id=" + url, {
            method: "GET", // or 'PUT'
            headers: {
              Accept: "*/*",
              Authorization: "Bearer " + user.Token,
            },
          })
            .then((response) => response.blob())
            .then((data) => {
              const file = window.URL.createObjectURL(data);
              window.open(file);
            });
        });
      }, 2000);

    const getPDFGeneral = (url) =>
      new Promise((resolve, reject) => {
        setTimeout(() => {
          fetch(process.env.REACT_APP_API_URL + "pdfGeneral?id=" + url, {
            method: "GET", // or 'PUT'
            headers: {
              Accept: "*/*",
              Authorization: "Bearer " + user.Token,
            },
          })
            .then((response) => response.blob())
            .then((data) => {
              const file = window.URL.createObjectURL(data);
              window.open(file);
            });
        });
      }, 2000);

    let data = props.tableData;
    if (props.usingMutation && !props.mutation.isLoading && data) {
      data = data.data;
    }
    return (
      <>
      <Card className="flex flex-col items-center content-center">
        <>
          <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row">
            <form>
              {!props.SearchBar && (
                <div
                  className="relative text-gray-800 border rounded-md"
                  style={{ color: Colors.primary }}
                >
                  <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                    <button
                      type="submit"
                      className="p-1 focus:outline-none focus:shadow-outline"
                    >
                      <svg
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        className="w-6 h-6"
                      >
                        <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                      </svg>
                    </button>
                  </span>
                  <input
                    // type="search"
                    onChange={(e) => {
                      setSearch(e.target.value);
                      props.handleSearch(e.target.value);
                    }}
                    value={search}
                    className="py-2 text-sm text-gray-800 rounded-md pl-10 pr-2 bg-white focus:outline-none"
                    placeholder={"Search " + props.searchPlaceholder}
                    // autoComplete="on"
                  />
                </div>
              )}
            </form>
            {props.searchTipeKaryawan && (
              <div className="flex flex-row" style={{ color: Colors.primary }}>
                <select
                  value={searchTipeKaryawanValue}
                  onChange={(e) => {
                    setsearchTipeKaryawanValue(e.target.value);
                    props.searchTipeKaryawanHandler(e.target.value);
                  }}
                  name="TipeKaryawanID"
                  // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                  className={
                    "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  }
                  onClick={() => {
                    dispatch(getMinTipeKaryawan({ search: "" }));
                  }}
                >
                  <option defaultValue disabled value="" hidden>
                    -- Pilih Data --
                  </option>
                  {tipeKaryawan.minData.map((item, i) => (
                    <option
                      key={item.TipeKaryawanID}
                      value={item.NamaTipeKaryawan}
                    >
                      {item.NamaTipeKaryawan}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {props.bulan && (
              <div className="flex flex-row" style={{ color: Colors.primary }}>
                <DatePicker
                utcOffset={0}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                selected={props.valueBulan}
                name={"bulan"}
                className={"appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white h-10"}
                onChange={(text) => props.bulanHandler(text)}
              />
              </div>
            )}

            {/* className="flex flex-row border items-center my-4 sm:my-0" */}
            {props.addButton === false ? (
              <div></div>
            ) : (
              <div className="flex flex-row">
                <button
                  onClick={() =>
                    props?.modal({ showModalAdd: true, showModalEdit: false })
                  }
                  className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                >
                  <BiPlus className="text-xl text-gray-800" />
                  Tambah
                </button>
                {props.backButton === false || !props.backButton ? (
                  <div></div>
                ) : (
                  <button
                    onClick={() => navigate("/" + props.backUrl)}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                )}
              </div>
            )}
            {props.deleteButtonAbsen === true ? (
              (
                <div className="flex flex-row">
                  <button
                    onClick={() =>
                      props?.modal({ ShowModalAddDelete: true })
                    }
                    className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                  >
                    Delete Data
                  </button>
                </div>
              )
            ) : <div></div>}

            {props.redirectButton === true ? (
              <button
                onClick={() => navigate("/create-job-Request")}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                <BiPlus className="text-xl text-gray-800" />
                Tambah
              </button>
            ) : (
              <></>
            )}

            {props.quatationAdditional === true ? (
              <button
                onClick={() => navigate("/add-additional-quotation-or-contract")}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                <BiPlus className="text-xl text-gray-800" />
                Tambah
              </button>
            ) : (
              <></>
            )}
            {props.quatation === true ? (
              <button
                onClick={() => navigate("/add-quotation-or-contract")}
                className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              >
                <BiPlus className="text-xl text-gray-800" />
                Tambah
              </button>
            ) : (
              <></>
            )}
            
            {/* Custom Action Button */}
            {props.customAction ? (
              <div className="my-2 sm:my-0">
                {props.customAction}
              </div>
            ) : null}
          </div>
          <div className="w-full flex flex-row items-center justify-end px-4 pt-4">
            Show
            <div className="inline-block relative w-16 mx-1">
              <select
                value={currentCount}
                onChange={(e) => {
                  setCurrentCount(e.target.value);
                  setCurrentPage(1);
                  props.updateCount(e.target.value);
                }}
                className="block appearance-none w-full bg-white border hover:border-gray-800 pl-3 pr-2 py-1 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={-1}>All</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-700">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
            data
          </div>
          {props.fetching ? (
            <div className="flex items-center">
              <Spinner />
            </div>
          ) : (
            <CardBody className="w-full pt-0 ">
              <div className="overflow-x-auto relative ">
                <table className="table-auto w-full bg-transparent border-collapse text-sm">
                  <thead>
                    <tr>
                      {props.AccountID && (
                        <th
                          style={{ color: Colors.primary }}
                          className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          Account
                        </th>
                      )}
                      {props.colOneTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="w-1/12 font-bold px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colOneTitle}
                        </th>
                      )}
                      {props.colTwoTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colTwoTitle}
                        </th>
                      )}
                      {props.colThreeTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colThreeTitle}
                        </th>
                      )}

                      {props.colFourTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colFourTitle}
                        </th>
                      )}
                      {props.colFiveTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colFiveTitle}
                        </th>
                      )}
                      {props.colSixTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colSixTitle}
                        </th>
                      )}
                      {props.colSevenTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colSevenTitle}
                        </th>
                      )}
                      {props.colEightTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colEightTitle}
                        </th>
                      )}
                      {props.colNineTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colNineTitle}
                        </th>
                      )}
                      {props.colTenTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colTenTitle}
                        </th>
                      )}
                      {props.colElevenTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colElevenTitle}
                        </th>
                      )}
                      {props.colBoolTitle && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.colBoolTitle}
                        </th>
                      )}

                      {props.dateCol && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.dateCol}
                        </th>
                      )}
                      {props.dateColSecond && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.dateColSecond}
                        </th>
                      )}
                      {props.status && (
                        <th
                          style={{ color: Colors.primary }}
                          className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                        >
                          {props.status}
                        </th>
                      )}
                      {props.editEnabled && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.detail && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.statusCustomer && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}

                      {props.monitoringJR && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.permit && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.output && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.permintaanUnit && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                      {props.hrd && (
                        <th
                          style={{ color: Colors.primary }}
                          className="text-center w-1/12 font-bold px-2 align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-light text-left"
                        ></th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {props.usingMutation && props.mutation.isLoading ? (
                      <Skeltons />
                    ) : (
                      <>
                        {Array.isArray(data) ? (
                          data.map((keyName, i) => (
                            <tr key={keyName + i}>
                              {props.AccountID && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName["DetailAccountID"]}
                                </th>
                              )}
                              {props.colOneData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colOneData]}
                                </th>
                              )}
                              {props.colTwoData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colTwoData]}
                                </th>
                              )}
                              {props.colThreeData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colThreeData]}
                                </th>
                              )}
                              {props.colFourData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colFourData]}
                                </th>
                              )}
                              {props.colFiveData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colFiveData].replaceAll(
                                    "_",
                                    " "
                                  )}
                                </th>
                              )}
                              {props.colSixData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colSixData]}
                                </th>
                              )}
                              {props.colSevenData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colSevenData].replaceAll(
                                    "_",
                                    " "
                                  )}
                                </th>
                              )}

                              {props.colEightData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colEightData]}
                                </th>
                              )}
                              {props.colNineData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colNineData]}
                                </th>
                              )}
                              {props.colTenData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colTenData]}
                                </th>
                              )}
                              {props.colElevenData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {keyName[props.colElevenData]}
                                </th>
                              )}
                              {props.colBoolData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {(keyName[props.colBoolData]) ? 'Ya' : 'Tidak'}
                                </th>
                              )}

                              {props.dateColData && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {
                                    new Date(keyName[props.dateColData])
                                      .toISOString()
                                      .split("T")[0]
                                  }
                                </th>
                              )}
                              {props.dateColDataSecond && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  {
                                    new Date(keyName[props.dateColDataSecond])
                                      .toISOString()
                                      .split("T")[0]
                                  }
                                </th>
                              )}
                              {props.status && (
                                <th
                                  style={{ color: Colors.primary }}
                                  className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"
                                >
                                  {keyName[props.status] === "1" ||
                                  keyName[props.status] === 1
                                    ? "Aktif"
                                    : "Tidak Aktif"}
                                </th>
                              )}
                              {props.hrd && keyName["Status"] < "0" && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() => {
                                      if (props.redirectButton) {
                                        navigate("/detail-job-Request", {
                                          state: { JRID: keyName["JRID"] },
                                        });
                                      } else {
                                        props.modal({
                                          showModalAdd: false,
                                          showModalEdit: true,
                                        });
                                        props.currentData(keyName);
                                      }
                                    }}
                                    className="flex flex-row items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiEdit className="text-xl text-gray-800 mr-2" />
                                    <span>Edit</span>
                                  </button>

                                  <button
                                    onClick={() => {
                                      try {
                                        props.reapprove();
                                      } catch (error) {}
                                      dispatch(
                                        approve({
                                          primary: keyName[props.primaryID],
                                        })
                                      );
                                    }}
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                    <span>Send</span>
                                  </button>
                                </th>
                              )}
                              {props.hrd && keyName["Status"] > "0" && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></th>
                              )}
                              {props.editEnabled &&
                                ((props.transaksi
                                  ? !props.transaksi
                                  : !props.transaksiCustomer) ||
                                  keyName["Status"] <= "100") && (
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <button
                                      onClick={() => {
                                        if (props.redirectButton) {
                                          navigate("/detail-job-Request", {
                                            state: { JRID: keyName["JRID"] },
                                          });
                                        } else {
                                          // console.log(keyName);
                                          props.modal({
                                            showModalAdd: false,
                                            showModalEdit: true,
                                          });
                                          props.currentData(keyName);
                                        }
                                      }}
                                      className="flex flex-row items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      <BiEdit className="text-xl text-gray-800 mr-2" />
                                      <span>Edit</span>
                                    </button>

                                    {props.transaksi && (
                                      <button
                                        onClick={() => {
                                          dispatch(
                                            approve({
                                              primary: keyName[props.primaryID],
                                            })
                                          );
                                        }}
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                        <span>Send</span>
                                      </button>
                                    )}
                                    {keyName[props.akunUser] === "" && (
                                      <button
                                        onClick={() => {
                                          props.modal({
                                            showModalAdd: false,
                                            showModalEdit: false,
                                            showModalCreateAccount: true,
                                          });
                                          props.currentData(keyName);
                                        }}
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiEdit className="text-xl text-gray-800 mr-2" />
                                        <span>Create Akun Klien</span>
                                      </button>
                                    )}
                                    {/* { keyName[props.akunUser]!=="" && (
                                  <button
                                    onClick={() => {
                                      dispatch(
                                        kirimJobRequest({
                                          QuatationNo: keyName[props.primaryID],
                                        })
                                      );
                                    }}
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                    <span>Reset Akun Klien</span>
                                  </button>
                                )} */}
                                    {props.transaksiCustomer && (
                                      <button
                                        onClick={() => {
                                          dispatch(
                                            kirimJobRequest({
                                              JRID: keyName[props.primaryID],
                                            })
                                          );
                                        }}
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                        <span>Send</span>
                                      </button>
                                    )}
                                    {props.auth ? (
                                      <button
                                        onClick={() =>
                                          navigate(
                                            "/setup-otoritas/" +
                                              keyName["Username"]
                                          )
                                        }
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiPlus className="text-xl text-gray-800" />
                                        Otoritas
                                      </button>
                                    ) : (
                                      <></>
                                    )}
                                    {props.resetPassword ? (
                                      <button
                                        onClick={() => {
                                          dispatch(
                                            kirimResetPassword({
                                              Username: keyName["Username"],
                                            })
                                          ).then((response) => {
                                            if (
                                              response.payload.status == "Success"
                                            ) {
                                              setisSuccess(true);
                                            }
                                          });
                                        }}
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiLockOpen className="text-xl text-gray-800" />
                                        Reset Password
                                      </button>
                                    ) : (
                                      <></>
                                    )}
                                  </th>
                                )}
                              {props.detail && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      navigate("/quotation-detail-or-contract", {
                                        state: {
                                          QuatationNo: keyName["QuatationNo"],
                                        },
                                      })
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    {/* <BiCheckSquare className="text-xl text-gray-800 mr-2" /> */}
                                    <span>Detail</span>
                                  </button>
                                  {props.detailQuotation && (
                                    <button
                                      onClick={() =>
                                        navigate("/mjs", {
                                          state: {
                                            QuatationNo: keyName["QuatationNo"],
                                          },
                                        })
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      {/* <BiCheckSquare className="text-xl text-gray-800 mr-2" /> */}
                                      <span>MJS </span>
                                    </button>
                                  )}
                                  {props.detailQuotation && (
                                    <button
                                      onClick={() =>
                                        navigate("/finance/invoice/Quotation", {
                                          state: {
                                            QuatationNo: keyName["QuatationNo"],
                                          },
                                        })
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      {/* <BiCheckSquare className="text-xl text-gray-800 mr-2" /> */}
                                      <span>Invoice </span>
                                    </button>
                                  )}
                                </th>
                              )}

                              {props.statusCustomer &&
                                keyName["Status"] <= 100 && (
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <button
                                      onClick={() =>
                                        navigate(
                                          "/operasional-shipping-manifest-detail",
                                          {
                                            state: { JRID: keyName["JRID"] },
                                          }
                                        )
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      <BiDetail className="text-xl text-gray-800 mr-2" />
                                      <span>Check Shiping Manifest</span>
                                    </button>
                                    {props.statusCustomer &&
                                      keyName["Status"] === "100" && (
                                        <button
                                          onClick={() => {
                                            dispatch(
                                              kirimShippingManifest({
                                                JRID: keyName[props.primaryID],
                                              })
                                            );
                                          }}
                                          className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                        >
                                          <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                          <span>Send</span>
                                        </button>
                                      )}
                                  </th>
                                )}
                              {props.output &&
                                keyName["Status"] > 104 &&
                                keyName["Status"] <= 106 && (
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <button
                                      onClick={() =>
                                        navigate("/operasional-activity-detail", {
                                          state: { JRID: keyName["JRID"] },
                                        })
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      <BiDetail className="text-xl text-gray-800 mr-2" />
                                      <span>Activity</span>
                                    </button>
                                    {props.output &&
                                      keyName["Status"] === "106" && (
                                        <button
                                          onClick={() => {
                                            dispatch(
                                              kirimActivity({
                                                JRID: keyName[props.primaryID],
                                              })
                                            );
                                          }}
                                          className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                        >
                                          <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                          <span>Send</span>
                                        </button>
                                      )}
                                  </th>
                                )}
                              {props.permit &&
                                keyName["Status"] > 100 &&
                                keyName["Status"] <= 102 && (
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <button
                                      onClick={() =>
                                        navigate("/operasional-permit-detail", {
                                          state: { JRID: keyName["JRID"] },
                                        })
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      <BiDetail className="text-xl text-gray-800 mr-2" />
                                      <span>Permit</span>
                                    </button>
                                    {props.permit &&
                                      keyName["Status"] === "102" && (
                                        <button
                                          onClick={() => {
                                            dispatch(
                                              kirimPermit({
                                                JRID: keyName[props.primaryID],
                                              })
                                            );
                                          }}
                                          className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                        >
                                          <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                          <span>Send</span>
                                        </button>
                                      )}
                                  </th>
                                )}
                              {props.permintaanUnit &&
                                keyName["Status"] > 102 &&
                                keyName["Status"] <= 104 && (
                                  <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                    <button
                                      onClick={() =>
                                        navigate(
                                          "/operasional-permintaan-unit-detail",
                                          {
                                            state: { JRID: keyName["JRID"] },
                                          }
                                        )
                                      }
                                      className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                    >
                                      <BiDetail className="text-xl text-gray-800 mr-2" />
                                      <span>Permintaan Unit</span>
                                    </button>
                                    {props.permintaanUnit &&
                                      keyName["Status"] === "104" && (
                                        <button
                                          onClick={() => {
                                            dispatch(
                                              kirimPermintaanUnit({
                                                JRID: keyName[props.primaryID],
                                              })
                                            );
                                          }}
                                          className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                        >
                                          <BiCheckSquare className="text-xl text-gray-800 mr-2" />
                                          <span>Send</span>
                                        </button>
                                      )}
                                  </th>
                                )}
                              {props.monitoringJR && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      navigate(
                                        "/operasional-job-request-detail",
                                        {
                                          state: { JRID: keyName["JRID"] },
                                        }
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiDetail className="text-xl text-gray-800 mr-2" />
                                    <span>Detail</span>
                                  </button>
                                  {props.monitoringJR &&
                                    keyName["Status"] === "200" && (
                                      <button
                                        onClick={() =>
                                          navigate("/cetak-jr", {
                                            state: { JRID: keyName["JRID"] },
                                          })
                                        }
                                        className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                      >
                                        <BiPrinter className="text-xl text-gray-800 mr-2" />
                                        <span>Print JR</span>
                                      </button>
                                    )}
                                </th>
                              )}
                              {props.monitoringFinance && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      navigate(
                                        "/operasional-job-request-detail",
                                        {
                                          state: { JRID: keyName["JRID"] },
                                        }
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiDetail className="text-xl text-gray-800 mr-2" />
                                    <span>Detail</span>
                                  </button>
                                </th>
                              )}
                              {props.monitoringReportFinance && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      navigate(
                                        "/operasional-job-request-detail",
                                        {
                                          state: { JRID: keyName["JRID"] },
                                        }
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiDetail className="text-xl text-gray-800 mr-2" />
                                    <span>Detail</span>
                                  </button>

                                  <button
                                    // onClick={() =>
                                    //     navigate("/report-mjs", {
                                    //         state: {JRID: keyName["JRID"]},
                                    //     })}
                                    onClick={() =>
                                      getPDFGeneral(
                                        "KD001/" +
                                          "Invoice_" +
                                          keyName["InvoiceNo"] +
                                          ".pdf"
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiPrinter className="text-xl text-gray-800 mr-2" />
                                    <span>Cetak</span>
                                  </button>
                                </th>
                              )}
                              {props.deleteButton && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      dispatch(
                                        deletePerbaikanTransaksi({
                                          ID: keyName[props.primaryID],
                                        })
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiDetail className="text-xl text-gray-800 mr-2" />
                                    <span>Delete</span>
                                  </button>
                                </th>
                              )}
                              {props.deleteButtonLembur && (
                                <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                  <button
                                    onClick={() =>
                                      dispatch(
                                        deleteLembur({
                                          ID: keyName[props.primaryID],
                                        })
                                      )
                                    }
                                    className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                  >
                                    <BiDetail className="text-xl text-gray-800 mr-2" />
                                    <span>Delete</span>
                                  </button>
                                </th>
                              )}
                              {/* {props.statusCustomer && keyName["Status"] === "99" && (
                            <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                              <button
                                onClick={() => navigate('/operasional-job-request-detail/' + keyName["JRID"] )}
                                className="flex flex-row mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                              >
                                <span>Detail</span>
                              </button>
                            </th>
                          )} */}
                            </tr>
                          ))
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          )}
          {!props.usingMutation && !props.tableData && !props.fetching && (
            <div className="w-full flex flex-col justify-center items-center">
              <BsFileEarmarkExcelFill className="text-7xl py-2 text-gray-400" />
              <div className="pb-4 text-gray-800">No Data</div>
            </div>
          )}
          <nav aria-label="Pagination" className="my-2">
            <ul className="flex">
              <li>
                <a
                  onClick={() => {
                    if (currentPage > 1) {
                      setCurrentPage(currentPage - 1);
                      props.updatePage(currentPage - 1);
                    }
                  }}
                  href="#"
                  className="py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                >
                  Previous
                </a>
              </li>
              {props.maxPage > 0 && (
                <li>
                  <a
                    onClick={() => {
                      setCurrentPage(pagingOne);
                      props.updatePage(pagingOne);
                    }}
                    href="#"
                    className={`${
                      currentPage === pagingOne &&
                      "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                    } py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                  >
                    {pagingOne}
                  </a>
                </li>
              )}
              {props.maxPage > 1 && (
                <li>
                  <a
                    onClick={() => {
                      setCurrentPage(pagingTwo);
                      props.updatePage(pagingTwo);
                    }}
                    href="#"
                    className={`${
                      currentPage === pagingTwo &&
                      "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                    } py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                  >
                    {pagingTwo}
                  </a>
                </li>
              )}
              {props.maxPage > 2 && (
                <li>
                  <a
                    onClick={() => {
                      setCurrentPage(pagingThree);
                      props.updatePage(pagingThree);
                    }}
                    href="#"
                    aria-current="page"
                    className={`${
                      currentPage === pagingThree &&
                      "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                    } py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                  >
                    {pagingThree}
                  </a>
                </li>
              )}
              {width > breakpoint && props.maxPage > 3 && (
                <li>
                  <a
                    onClick={() => {
                      setCurrentPage(pagingFour);
                      props.updatePage(pagingFour);
                    }}
                    href="#"
                    className={`${
                      currentPage === pagingFour &&
                      "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                    } py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                  >
                    {pagingFour}
                  </a>
                </li>
              )}
              {width > breakpoint && props.maxPage > 4 && (
                <li>
                  <a
                    onClick={() => {
                      setCurrentPage(pagingFive);
                      props.updatePage(pagingFive);
                    }}
                    href="#"
                    className={`${
                      currentPage === pagingFive &&
                      "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                    } py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                  >
                    {pagingFive}
                  </a>
                </li>
              )}
              <li>
                <a
                  onClick={() => {
                    if (currentPage < props.maxPage) {
                      setCurrentPage(currentPage + 1);
                      props.updatePage(currentPage + 1);
                    }
                  }}
                  href="#"
                  style={{ paddingLeft: 26.258, paddingRight: 26.258 }}
                  className="w-full py-2 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                >
                  Next
                </a>
              </li>
            </ul>
          </nav>
        </>
      </Card>

    </>
  );
  }
